package com.milta.feature.profile.data.repository

import com.milta.feature.profile.data.remote.ProfileApi
import com.milta.feature.profile.data.remote.dto.toDomain
import com.milta.feature.profile.domain.entity.DriverEnterprise
import com.milta.feature.profile.domain.repository.DriverEnterprisesRepository

class DriverEnterprisesRepositoryImpl(private val api: ProfileApi) : DriverEnterprisesRepository {
    override suspend fun getMyEnterprises(): Result<List<DriverEnterprise>> = runCatching {
        api.getMyEnterprises().map { it.toDomain() }
    }
}
